<template>

    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" >Finalizar Compra</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <form  @submit.prevent="validarCampos()" >
            <div class="modal-body">
                <button type="button" class="btn btn-primary" @click="etapaAtiva=1">etapa 1</button>
                <button type="button" class="btn btn-primary" v-bind:disabled="!etapasFinalizar.etapa1" @click="etapaAtiva=2" >etapa 2</button>
                <button type="button" class="btn btn-primary" v-bind:disabled="!etapasFinalizar.etapa2">etapa 3</button>
                <button type="button" class="btn btn-primary" v-bind:disabled="!etapasFinalizar.etapa3">etapa 4</button>

                <button type="button" class="btn btn-primary" v-on:click="$emit('componente-ativo', 'endereco')" ></button>

                <div>
                    <div v-if="etapaAtiva == 1">
                        <p>Mostrar Etapa 1</p>
                    </div>
                    <div v-if="etapaAtiva == 2">
                        <p>Mostrar Etapa 2</p>
                    </div>
                    <div v-if="etapaAtiva == 3">
                        <p>Mostrar Etapa 3</p>
                    </div>
                    <div v-if="etapaAtiva == 4">
                        <p>Mostrar Etapa 4</p>
                    </div>
                </div>


                <div class="text-center">
                    <h3 class="b-hn">Valor Total R$ {{formatarMoeda(valorTotalComp)}}</h3>
                </div>

                <div class="card my-2">
                    <div class="card-header">
                        <h4 class="card-title">Como vai ser a forma de entrega?</h4>
                    </div>
                    <div class="card-body">
                        <div v-if="inquilino.entrega_balcao" class="d-flex flex-row my-3">
                            <div class="custom-control custom-radio">
                                <input type="radio" id="balcao" name="entrega" class="custom-control-input" value=1 v-model.number="form.entrega_id">
                                <label class="custom-control-label" for="balcao">Vou retirar no Balcão  </label><i class="ml-2 fas fa-info-circle" data-toggle="collapse" href="#collapseBalcao" role="button" aria-expanded="false" aria-controls="collapseBalcao"></i>
                            </div>
                            <div class="ml-auto">
                                <div style="width:110px; text-align: center ">
                                    <span >Frete R$ 0,00</span>

                                </div>
                            </div>
                        </div>
                        <div class="collapse" id="collapseBalcao">
                            <div class="card text-white bg-info card-body">
                                Essa opção permite que você faça o pedido através do aplicativo VSMenu e retire a sua refeição diretamente no balcão do restaurante. É uma opção prática e rápida, ideal para quem não tem muito tempo disponível ou prefere não esperar pela entrega.
                            </div>
                        </div>
                        <hr>
                        <div v-if="inquilino.entrega_local" class="d-flex flex-row my-3">
                            <div class="custom-control custom-radio">
                                <input type="radio" id="local" name="entrega" class="custom-control-input" value=3 v-model.number="form.entrega_id">
                                <label class="custom-control-label" for="local">Vou comer no local</label> <i class="ml-2 fas fa-info-circle" data-toggle="collapse" href="#collapseLocal" role="button" aria-expanded="false" aria-controls="collapseLocal"></i>
                            </div>
                            <div class="ml-auto">
                                <div style="width:110px; text-align: center ">
                                    <span >Frete R$ 0,00</span>

                                </div>
                            </div>
                        </div>
                        <div class="collapse" id="collapseLocal">
                            <div class="card text-white bg-info card-body">
                                Essa opção permite que você faça o pedido através do aplicativo VSMenu e consuma a sua refeição no próprio restaurante. É uma ótima opção para quem quer experimentar novos sabores e ambientes, além de poder contar com o atendimento personalizado e o ambiente acolhedor do estabelecimento.
                            </div>
                        </div>
                        <hr>

                        <template v-if="inquilino.entrega_endereco">

                            <template v-if="Object.keys(endereco).length != 0">

                                <div class="d-flex flex-row my-3">
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="endereco" name="entrega" class="custom-control-input" value=2 v-model.number="form.entrega_id">
                                        <label class="custom-control-label" for="endereco">Entregue no meu endereço</label> <i class="ml-2 fas fa-info-circle" data-toggle="collapse" href="#collapseEndereco" role="button" aria-expanded="false" aria-controls="collapseEndereco"></i>
                                    </div>
                                    <div class="ml-auto">
                                        <div style="width:110px; text-align: center ">
                                            <span >Frete R$ {{ formatarMoeda(endereco.bairro.frete) }}</span>

                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-row my-3">
                                    <span > {{
                                        endereco.logradouro+ ', '+
                                        endereco.numero+', '+
                                        endereco.complemento+', '+
                                        endereco.bairro.nome+', '+
                                        endereco.cidade_nome+' - CEP: '+
                                        endereco.cep+' - '+
                                        endereco.referencia  }}
                                    </span>
                                </div>
                                <div class="collapse" id="collapseEndereco">
                                    <div class="card text-white bg-info card-body">
                                        Essa opção permite que você faça o pedido através do aplicativo VSMenu e receba a sua refeição no conforto da sua casa, escritório ou onde estiver. É uma opção prática e cômoda, ideal para quem quer desfrutar das delícias do restaurante sem precisar sair de casa ou se deslocar até o estabelecimento.
                                    </div>
                                </div>

                            </template>
                            <div v-else >
                                <p>endereço não cadastrado</p>
                                <a @click="modalEndereco()" class="btn b-btn " role="button"> Cadastrar novo endereço</a>
                            </div>

                        </template>



                    </div>
                </div>


                <div class="card my-2">
                    <div class="card-body">


                        <div class="row">
                            <div class="col">
                                <input v-model="form.codigo_desconto" type="text" class="form-control  mr-2 rounded" placeholder="CUPOM DE DESCONTO">
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn b-btn" @click="validarCupom()" >INSERIR CUPOM</button>
                            </div>
                        </div>
                        <div v-if="!carregandoCupom" class="row">
                            <div class="col">
                                <div v-if="cupom_mensage!=''">

                                    <div v-if="!cupom_erro" class="alert alert-success my-3" role="alert">
                                        {{cupom_mensage}}
                                    </div>

                                    <div v-else class="alert alert-danger my-3" role="alert">
                                        {{cupom_mensage}}
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div v-else class="text-center">
                            <div class="spinner-border text-info my-5" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>







                    </div>
                </div>



                <div class="card my-2">
                    <div class="card-body">

                        <table class="table">
                            <tr v-if="form.entrega_id==2">
                                <th>Valor dos itens:</th>
                                <td class="text-right">R$ {{formatarMoeda(valorItens)}}</td>
                            </tr>
                            <tr v-if="form.entrega_id==2">
                                <th>Frete</th>
                                <td class="text-right">R$ {{formatarMoeda(valorFrete)}}</td>
                            </tr>
                            <tr v-if="desconto>0">
                                <th>Sub-total</th>
                                <td class="text-right">R$ {{formatarMoeda(valorTotalComp)}}</td>
                            </tr>
                            <tr v-if="desconto>0">
                                <th>Desconto</th>
                                <td class="text-right">- R$ {{formatarMoeda(calculoCupom)}}</td>
                            </tr>
                            <tr>
                                <th><h3>Valor Total:</h3></th>
                                <td class="text-right"><h3>R$ {{formatarMoeda(valorTotalComp2)}}</h3></td>
                            </tr>
                        </table>

                    </div>
                </div>




                <div class="card my-2">
                    <div class="card-header">
                        <h4 class="card-title">Como deseja Pagar?</h4>
                    </div>
                    <div class="card-body">

                        <div class="row">
                            <div v-for="pagamento in formasPagamento.filter(pagamento => pagamento.disponivel)" :key="pagamento.id" class="col-4">
                                <div v-if="pagamento.id==1" class="info-box" @click="form.pagamento_id=1" >
                                    <span  class="info-box-icon bg-success elevation-1">
                                        <i class="fas fa-money-bill"></i>
                                    </span>
                                    <div class="info-box-content">
                                        <span class="info-box-text">{{pagamento.nome}}</span>
                                    </div>
                                    <span  v-if="form.pagamento_id==1" class="check"><i class="fas fa-check-circle"></i></span>
                                </div>

                                <div v-if="pagamento.id==2" class="info-box" @click="form.pagamento_id=2" >
                                    <span  class="info-box-icon bg-warning elevation-1">
                                        <i class="fas fa-credit-card"></i>
                                    </span>
                                    <div class="info-box-content">
                                        <span class="info-box-text">{{pagamento.nome}}</span>
                                    </div>
                                    <span  v-if="form.pagamento_id==2" class="check"><i class="fas fa-check-circle"></i></span>
                                </div>

                                <div v-if="pagamento.id==3" class="info-box" @click="form.pagamento_id=3" >
                                    <span  class="info-box-icon bg-info elevation-1">
                                        <i class="fas fa-mobile-alt"></i>
                                    </span>
                                    <div class="info-box-content">
                                        <span class="info-box-text">{{pagamento.nome}}</span>
                                    </div>
                                    <span  v-if="form.pagamento_id==3" class="check"><i class="fas fa-check-circle"></i></span>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="form.pagamento_id==2">
                            <div v-for="bandeira in bandeiras" :key="bandeira.id" class="col-3 px-1">
                                <div class="info-box"  @click="form.bandeira_id=bandeira.id" >
                                    <span  class="info-box-img elevation-1">
                                        <img :src="bandeira.imagem_url ||'/media/images/card.png'" width="70" height="40" :alt="bandeira.nome" class="img-bord">
                                    </span>
                                    <div class="info-box-content">
                                        <span class="info-box-text info-bandeira-text">{{bandeira.nome}}</span>
                                    </div>
                                    <span  v-if="form.bandeira_id==bandeira.id" class="check-card"><i class="fas fa-check-circle"></i></span>
                                </div>
                            </div>

                        </div>

                        <div v-if="form.pagamento_id == 1">
                            <label class="control-label" for="troco">Troco para:</label>
                            <money
                                v-model="form.troco"
                                type="text"
                                id="troco" name="troco"
                                class="form-control form-control-lg"
                                :class="{ 'is-invalid': form.errors.has('troco') }"
                                :disabled="form.pagamento_id != 1"
                            >
                            </money>
                        </div>

                        <div class="row" v-if="form.pagamento_id==3">
                            <div class="col">
                                <h4>Chave Pix:</h4>
                                <p>
                                    <span class="pix">
                                        <input type="text" ref="copiar" :value="formasPagamento.find(pagamento =>pagamento.id==3).chave" readonly>
                                        <i @click="copiarTexto()" class="far fa-clone"></i>
                                    </span>
                                </p>


                                <h6>Tipo: {{formasPagamento.find(pagamento =>pagamento.id==3).tipo_de_chave}}</h6>
                                <h6>Titular: {{formasPagamento.find(pagamento =>pagamento.id==3).nome_do_titular}} </h6>
                            </div>

                        </div>



                    </div>
                </div>

                <div class="card my-3 p-3 d-flex flex-colunm">
                    <div style="max-width: 300px;" class="mb-3">
                        <h5>Observações Gerais</h5>
                    </div>
                    <div>
                        <textarea v-model="form.obs" ></textarea>
                    </div>
                </div>


            </div>



            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                <button type="submit" class="btn b-btn" :disabled="isLoading">Finalizar Compra</button>
            </div>
        </form>
    </div>

</template>

<script>
import api from "../../service/api";

export default {
    data () {
        return {
            isLoading: null,
            status:'',
            carregando:false,
            enviando_pedido:false,
            valorTotal:0,
            endereco:null,
            mudarModal:false,
            bandeiras:[],
            formasPagamento:[],
            carregandoCupom:false,
            cupom:{},
            desconto:0,
            cupom_mensage:'',
            codigo_desconto:'',
            cupom_erro:false,
            inquilino:{},

            etapaAtiva:1,

            etapasFinalizar:{
                etapa1: true,
                epapa2: true,
                etapa3: false,
                etapa4: false,
            },

            form: new Form({
                cupom_id: '',
                codigo_desconto: '',
                usuario_id: '',
                endereco_id: '',
                pagamento_id: '',
                bandeira_id: '',
                entrega_id: null,
                troco: '',
                frete: '',
                obs: '',
                itens: []

            }),
        }
    },

    watch: {

        'form.entrega_id': function (n) {
            if (n==2) {
                this.form.frete = parseFloat(this.endereco.bairro.frete)
            }else{
                this.form.frete = 0
            }
            if (this.form.codigo_desconto != "") {
                this.validarCupom();
            }
        },

        'usuario.endereco_padrao_id': function () {
            this.carregarDados();
        },

        produtosDoCarrinho: function () {
            this.carregarDados();

            if (this.isEmptyObject(this.cupom)) {

                this.validarCupom();
            }

        },

        /* endereco: function () {
            this.form.entrega_id = 1;
        }, */


    },

    computed: {

        produtosDoCarrinho() {
            return this.$store.state.produtosSelecionados.main;
        },

        valorItens(){

            let valorProduto = 0;

            for (let index = 0; index < this.produtosDoCarrinho.length; index++) {
                valorProduto += this.setarValor(this.produtosDoCarrinho[index])
            }

            return valorProduto;
        },

        valorFrete(){

            let valorProduto = 0;

            if (this.form.entrega_id==2) {
                valorProduto += parseFloat(this.endereco.bairro.frete)
            }

            return valorProduto;
        },

        calculoCupom(){
            if (!this.cupom_erro) {
                if (this.cupom.tipo==1) {
                    let desconto = (this.valorTotalComp*this.cupom.desconto)/100;
                    return desconto;
                }else{
                    let desconto = this.cupom.desconto;
                    return desconto;
                }
            }else{
                return 0;
            }

        },

        valorTotalComp2(){

            return this.valorItens+this.valorFrete-(this.calculoCupom||0);
        },


        valorTotalComp(){

            let valorProduto = 0;

            for (let index = 0; index < this.produtosDoCarrinho.length; index++) {
                valorProduto += this.setarValor(this.produtosDoCarrinho[index])
            }

            if (this.form.entrega_id==2) {
                valorProduto += parseFloat(this.endereco.bairro.frete)
            }

            return valorProduto;
        },

        logado() {

            if (JSON.stringify(this.$store.state.perfil.main)==='{}') {
                return false
            }else{
                return true
            }
        },

        usuario() {

            if (JSON.stringify(this.$store.state.perfil.main)==='{}') {
                return null
            }else{
                return this.$store.state.perfil.main
            }
        },


    },

    methods: {

        async carregarInquilino(){

            this.carregando = true;
            await api
            .get('/inquilino')
            .then(response => (this.inquilino = response.data));

            this.carregando = false
        },

        copiarTexto(){

            var copyTextarea = this.$refs.copiar

            copyTextarea.select();

            try {
                document.execCommand('copy');
                alert('Texto copiado');
            } catch (err) {
                alert('Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C.');
            }


        },

        async loadEndereco(){
            this.carregando = true;
            await api
            .get('/login-user/endereco-padrao')
            .then(response => (this.endereco = response.data));

            this.carregando = false
        },

        async loadBandeiras(){
            this.carregando = true;
            await api
            .get('/bandeiras')
            .then(response => (this.bandeiras = response.data));

            this.carregando = false
        },

        async carregarFormasPagamento(){
            this.carregando = true;
            await api
            .get('/formas-pagamentos')
            .then(response => (this.formasPagamento = response.data));

            this.carregando = false
        },

        verificarStatus(){
          api
          .get('/status')
          .then(response => (this.status = response.data.status));
        },

        validarCampos(){
            this.isLoading = true

            setTimeout(() => {
                this.isLoading = false
            }, 1000)

            if (this.valorTotalComp2<this.inquilino.valor_minimo) {
                Swal.fire({
                        title: 'Valor minimo não alcançado',
                        text: "O valor minimo para esse pedido é de: R$ "+this.formatarMoeda(this.inquilino.valor_minimo),
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok!'
                    })
            }else if  (this.form.entrega_id==null) {

                Swal.fire({
                        title: 'Selecione a forma de entrega',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok!'
                    })

            }else if  (this.form.entrega_id==2&&this.endereco.bairro.disponivel==0) {

                Swal.fire({
                    title: 'Desculpe',
                    text: 'No momento não estamos realizando entrega para o seu Bairro',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok!'
                })

            }else if (this.form.pagamento_id=="") {

                Swal.fire({
                        title: 'Escolha uma forma de Pagamento',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok!'
                    })

            }else if (this.form.pagamento_id==2) {

                if (this.form.bandeira_id=="") {

                    Swal.fire({
                        title: 'Você deve escolher uma bandeira para essa forma de Pagamento',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok!'
                    })

                }else{
                    this.enviarPedido();
                }

            }else {
                this.enviarPedido();
            }
        },

        async validarCupom(){
            this.carregandoCupom = true;

            let formData = new FormData();

            formData.append('codigo', this.form.codigo_desconto);
            formData.append('usuario_id', this.form.usuario_id);
            formData.append('valor', this.form.frete+this.valorItens);

            await api.post('/cupons/validar' ,formData)
            .then((response) => {

                if (response.data.success) {

                    if ((response.data.cupom.entrega_balcao==1 && this.form.entrega_id == 1)||(response.data.cupom.entrega_delivery==1 && this.form.entrega_id == 2)) {
                        this.cupom = response.data.cupom;
                        this.form.cupom_id = response.data.cupom.id;
                        this.desconto = response.data.valor_desconto;
                        this.cupom_mensage = 'Cupom Válido';
                        this.cupom_erro = false;
                    }else{
                        this.desconto = 0;
                        this.cupom = {};
                        this.form.cupom_id = null;
                        this.cupom_mensage = 'Cupom não é valido para a forma de entrega selecionada';
                        this.cupom_erro = true;
                    }

                }else{
                    this.desconto = 0;
                    this.cupom_mensage = response.data.message
                    this.cupom_erro = true
                }
                this.carregandoCupom = false;

            })
            .catch(() => {
                this.$Progress.fail();
                this.carregandoModal = false;
                Toast.fire({
                        icon: 'error',
                        title: 'Algo deu errado!'
                    });
                this.cupom_erro = true
                this.carregandoCupom = false;
            });

        },

        async enviarPedido(){
            this.verificarStatus();
            if (this.status=="Aberto") {


                this.carregando = true;
                this.enviando_pedido = true;
                await this.form
                .post('/api/pedidos')
                .then((response)=>{
                    if(response.data.success){

                        $('#modalFinalizarCompra').modal('hide');
                        this.$store.dispatch('limparProdutos').then();
                        this.form.reset();
                        this.form.errors.errors = {};
                        this.carregarDados();

                        Toast.fire({
                                icon: 'success',
                                title: response.data.message
                        });

                        this.$router.push("/site/pedidos");

                    } else {

                        this.form.errors.errors =  response.data.error;

                        Toast.fire({
                            icon: 'error',
                            title: 'Erro na resposta'
                        });

                        // this.$Progress.failed();
                    }
                })
                .catch((e)=>{

                    if (e.errors) {

                        Swal.fire({
                            title: 'Estabelecimento Fechado!',
                            text: "Tente comprar durante o horário de expediente",
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'Ok!'
                        }).then((result) => {

                            // Send request to the server
                            if (result.value) {
                                $('#modalFinalizarCompra').modal('hide');
                            }
                        })
                    }

                    console.log(e)
                    Toast.fire({
                        icon: 'error',
                        title: 'Algo deu errado!'
                    });
                })

                this.carregando = false;
                this.enviando_pedido = false;
            }else{

                Swal.fire({
                    title: 'Estabelecimento Fechado!',
                    text: "Tente comprar durante o horário de expediente",
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok!'
                }).then((result) => {

                    // Send request to the server
                    if (result.value) {
                        $('#modalFinalizarCompra').modal('hide');
                    }
                })



            }
        },

        setarValor(item) {

            if (item.tipo==1) {
                let valorProduto = 0;
                let valorOpcional = 0;
                let valorAdicional = 0;
                let valorEtapas = 0;

                if (item.produto.promocao) {
                    valorProduto += parseFloat(item.produto.promocao.valor);
                }else{
                    valorProduto += parseFloat(item.produto.valor);
                }

                if (item.produto.grupoopcional) {
                    if (item.produto.grupoopcional.multipla_escolha==1) {
                        for (let index = 0; index < item.opcionais.length; index++) {
                            valorOpcional += parseFloat(item.opcionais[index].valor)
                        }
                    }else{
                        if (item.opcionais.valor) {
                            valorOpcional += parseFloat(item.opcionais.valor)
                        }else{
                            valorOpcional += 0
                        }
                    }

                }


                /* for (let index = 0; index < item.opcionais.length; index++) {
                    valorOpcional += parseFloat(item.opcionais[index].valor)
                } */

                for (let index = 0; index < item.adicionais.length; index++) {
                    valorAdicional += parseFloat(item.adicionais[index].valor)
                }

                for (let index = 0; index < item.etapas.length; index++) {
                    valorEtapas += parseFloat(item.etapas[index].pivot.valor)
                }

                return item.quantidade*(valorProduto+valorOpcional+valorAdicional+valorEtapas)

                }else if(item.tipo==2){

                    let valorTotalSabores = parseFloat(0);
                    let valorBorda = parseFloat(item.borda.valor??0);
                    let valorMassa = parseFloat(item.massa.valor??0);
                    let valorAdicional = 0;
                    let valorSabor = 0;

                    for (let index = 0; index < item.sabores.length; index++) {

                        if (item.sabores[index].promocao) {
                            valorTotalSabores += parseFloat(item.sabores[index].promocao.valor);
                        }else{
                            valorTotalSabores += parseFloat(item.sabores[index].valor)
                        }

                    }

                    if (item.sabores.length>0) {
                        valorSabor = valorTotalSabores/item.sabores.length;
                    }

                    for (let index = 0; index < item.tamanho.adicionais.length; index++) {
                        valorAdicional += parseFloat(item.tamanho.adicionais[index].valor)
                    }

                    return item.quantidade*(valorSabor+valorBorda+valorMassa+valorAdicional)

                }else if(item.tipo==3){


                    let valorPizza = parseFloat(item.valor);
                    let valorTotal = parseFloat(0);
                    let valorAdicionais = parseFloat(0);

                    for (let index = 0; index < item.produtos.length; index++) {
                        valorTotal += parseFloat(item.produtos[index].borda.valor??0);
                        valorTotal += parseFloat(item.produtos[index].massa.valor??0);

                        item.produtos[index].adicionais.forEach(adicional => {
                            valorAdicionais += parseFloat(adicional.valor||0);
                        });
                    }

                    return item.quantidade*(valorPizza+valorTotal+valorAdicionais);

                }



        },

        formatarMoeda(valor){
            return parseFloat(valor).toFixed(2).replace(".",",")
        },

        async carregarDados(){

            await this.loadEndereco();

            this.montarDados();


        },

        montarDados(){
            this.form.usuario_id = this.usuario.id ;
            this.form.endereco_id = this.usuario.endereco_padrao_id ;
            // this.form.pagamento_id = 1 ;

            if (Object.keys(this.endereco).length != 0 && this.inquilino.entrega_endereco == true ) {
                this.form.entrega_id = 2 ;
            }else{
                this.form.entrega_id = null ;
            }

            let itens = [];

            for (let index = 0; index < this.produtosDoCarrinho.length; index++) {

                if (this.produtosDoCarrinho[index].tipo==1) {
                    let opcionais = [];
                    let mp_itens = [];
                    if (this.produtosDoCarrinho[index].produto.grupoopcional) {
                        if (this.produtosDoCarrinho[index].produto.grupoopcional.multipla_escolha==1) {
                            for (let index2 = 0; index2 < this.produtosDoCarrinho[index].opcionais.length; index2++) {
                                opcionais.push( this.produtosDoCarrinho[index].opcionais[index2].id);
                            }
                        }else{
                            opcionais.push( this.produtosDoCarrinho[index].opcionais.id);
                        }
                    }

                    if (this.produtosDoCarrinho[index].produto.etapas) {
                        for (let index2 = 0; index2 < this.produtosDoCarrinho[index].etapas.length; index2++) {
                            mp_itens.push( this.produtosDoCarrinho[index].etapas[index2]);
                        }
                    }



                    itens.push({
                        'tipo': 1,
                        'quantidade':  this.produtosDoCarrinho[index].quantidade,
                        'produto_id': this.produtosDoCarrinho[index].produto.id,
                        'obs': this.produtosDoCarrinho[index].obs,
                        'opcionais_ids': opcionais,
                        'mp_itens': mp_itens
                    });
                }else if (this.produtosDoCarrinho[index].tipo==2) {
                    let sabores = [];

                    for (let index2 = 0; index2 < this.produtosDoCarrinho[index].sabores.length; index2++) {
                        sabores.push( this.produtosDoCarrinho[index].sabores[index2].id);
                    }

                    itens.push({
                        'tipo': 2,
                        'quantidade':  this.produtosDoCarrinho[index].quantidade,
                        'tamanho_id': this.produtosDoCarrinho[index].tamanho.id,
                        'borda_id': this.produtosDoCarrinho[index].borda.id??0,
                        'massa_id': this.produtosDoCarrinho[index].massa.id??0,
                        'sabores_ids': sabores,
                        'obs': this.produtosDoCarrinho[index].obs,
                    });
                }else if (this.produtosDoCarrinho[index].tipo==3) {
                    let produtos = [];

                    for (let index2 = 0; index2 < this.produtosDoCarrinho[index].produtos.length; index2++) {
                        let sabores = [];

                        for (let index3 = 0; index3 < this.produtosDoCarrinho[index].produtos[index2].sabores.length; index3++) {
                            sabores.push( this.produtosDoCarrinho[index].produtos[index2].sabores[index3].id);
                        }

                        produtos.push({
                            "tipo":2,
                            "tamanho_id": this.produtosDoCarrinho[index].tamanho_id,
                            "borda_id": this.produtosDoCarrinho[index].produtos[index2].borda.id??0,
                            "massa_id": this.produtosDoCarrinho[index].produtos[index2].massa.id??0,
                            "sabores_ids": sabores,
                            "obs": this.produtosDoCarrinho[index].produtos[index2].obs
                        });
                    }

                    itens.push({
                        'tipo': 3,
                        'quantidade':  this.produtosDoCarrinho[index].quantidade,
                        'nome': this.produtosDoCarrinho[index].nome,
                        'clone_id': this.produtosDoCarrinho[index].clone_id,
                        'valor': this.produtosDoCarrinho[index].valor,
                        'produtos': produtos,
                        'obs': this.produtosDoCarrinho[index].obs,
                    });
                }




            }

            this.form.itens = itens ;

        },

        async modalEndereco(){
            this.mudarModal = true;
            await this.$store.dispatch('removerEnderecoAtivo').then();
            Cookie.set('proximaPagina', 'finalizarCompra' );
            await this.$store.dispatch('showModalEndereco').then();

            $('#modalFinalizarCompra').modal('hide');

            setTimeout(function() {
                $('#modalEndereco').modal('show')
            }, 400);

                // this.mudarModal = false;
                // $('#modalEndereco').modal('show');
        },



        isEmptyObject(obj) {
                return !!Object.values(obj).length;
        }






    },


    mounted() {
        this.carregarDados();
        this.verificarStatus();
        this.loadBandeiras();
        this.carregarFormasPagamento();
        this.carregarInquilino();


    }

}
</script>

<style scoped>

.card {
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0),rgba(0,0,0,0), rgba(0,0,0,0.07));
    border: 1px solid rgba(0, 0, 0, 0.20);
    border-radius: 0.8rem;
}

.card textarea{
    width: 100%;
    height: 100px;
    padding: 5px;
}

.title{
    text-align: center;
}

.title img {
    margin-left: 20px;
    padding: 4px;
    border: 1px solid #9c9c9c;
    border-radius: 2px;
    object-fit: cover;
    box-shadow: 2px 2px 4px 0px #a7a7a7;
}

.qt{
    display: inline-block;
    border: 1px solid rgba(0, 0, 0, 0.20);
    font-size: 1.2rem;
    width: 35px;
    height: 30px;
    text-align: center;
}

.img-bord{
    border: 1px solid rgb(167, 167, 167);
    border-radius: 5px;
    object-fit: cover;
}

.info-box {
    box-shadow: 0 0 1px rgb(0 0 0 / 13%), 0 1px 3px rgb(0 0 0 / 20%);
    border-radius: 0.25rem;
    background-color: #fff;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    min-height: 100px;
    padding: 0.5rem;
    position: relative;
    cursor: pointer;
}
.info-box:hover{
    box-shadow: 0px 0px 6px 1px #b9b9b9;
}

.info-box .info-box-icon {
    border-radius: 0.25rem;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    font-size: 2.5rem;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: center;
    height: 80px;
}

.info-box .info-box-img {
    border-radius: 0.25rem;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    font-size: 2.5rem;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: center;
}

.info-box .info-box-content {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    line-height: 1.8;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding: 0 10px;
    align-items: center;
    text-align: center;
}

.info-bandeira-text{
    font-size: 0.75rem;
}

.check{
    position: absolute;
    top: 10px;
    left: 15px;
    font-size: 28px;
    color: #fff;
}

.check-card{
    position: absolute;
    top: -4px;
    left: 60px;
    font-size: 28px;
    color: #fff;
}

.check i, .check-card i {
    filter: drop-shadow(0 0 6px #666666);
}

.pix input{
    display: block;
    padding: 10px;
    border: 1px solid #9b9b9b;
    border-radius: 8px;
    background-color: #fff;
    width: 100%;
}

.pix i{
    cursor: pointer;
    position: absolute;
    top: 45px;
    right: 30px;
}




</style>
